module.exports = __webpack_public_path__ + "static/media/SBF.d9940dc2.png";